import dogPng from './new-products-dog.png';

export const newProductsDog = [dogPng];
